import React from "react";
import {
  Xmark,
  CircleCheck,
  PlayFill,
  CircleExclamation,
} from "@gravity-ui/icons";

const ProgressInfoToast = ({
  type,
  message,
  onClose,
  action,
  loading,
  excludeCloseButton,
  className,
  imageSrc,
  currentStep,
  totalSteps,
}) => {
  const isPending = type === "info";
  const isError = type === "error";
  const isWarning = type === "warning";
  
  const mainMessage = message;

  return (
    <div
      className={`fixed md:top-4 top-20 z-30 flex flex-col gap-2 bg-[#1A1A1A] backdrop-blur-[10px] min-h-10 rounded-lg shadow-lg left-[50%] -translate-x-1/2 p-px overflow-hidden ${className}`}
    >
      <div className={`absolute inset-0 -z-10 bg-gradient-to-r from-[#fc10f2] to-[#3078e4] ${loading ? 'animate-pulse' : ''}`}/>

      <div className="flex items-center gap-2 w-full pl-2 p-1.5 pr-2 bg-[#1A1A1A] rounded-[7px] relative z-10">
        {imageSrc && (
          <img
            src={imageSrc}
            alt="Audio Cover"
            className="w-8 h-8 rounded object-cover flex-shrink-0"
          />
        )}

        <div className="flex w-full flex-col gap-1 flex-grow min-w-0">
          <div className="flex w-full justify-between items-center gap-2 min-h-8">
            <span className="text-sm font-extralight text-white truncate">
              {mainMessage}
            </span>
            {action && (
              <div className="flex items-center ml-2 flex-shrink-0">
                <button
                  onClick={action.onClick}
                  className="flex flex-row items-center gap-1 text-black bg-white h-7 px-2.5 text-nowrap rounded-full hover:bg-white/90 text-xs font-normal flex-shrink-0"
                >
                  {type === "success" && (
                    <div className="text-black">
                      <PlayFill className="w-3.5 h-3.5" />
                    </div>
                  )}
                  {action.label}
                </button>
              </div>
            )}

            {!excludeCloseButton && (
              <button
                onClick={onClose}
                className="text-white/50 h-7 w-7 items-center justify-center flex rounded-full hover:bg-white/5 hover:text-white flex-shrink-0 ml-1"
              >
                <Xmark className="w-4 h-4" />
              </button>
            )}
          </div>

          {loading && totalSteps > 0 && (
            <div className="flex items-center justify-between gap-1 w-full pt-1">
              <div className="flex items-center gap-1 min-w-0">
                <img
                  src="/updates-modal/feature-update-icon-2.svg"
                  className="w-3 h-3 opacity-70 flex-shrink-0"
                  alt="Stems"
                />
                <span className="text-xs font-extralight text-[#C5C3C6] truncate">
                   Generating stems<span className="inline-block animate-pulse">...</span>
                </span>
              </div>
              <span className="text-xs font-extralight text-white flex-shrink-0 ml-2">
                {currentStep}/{totalSteps}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProgressInfoToast;
